import axios from 'axios';
import { message } from 'ant-design-vue';
import { useModal } from '../store/index';
const http = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/open' : '/api',
});

const headleError = (error) => {
  message.error(error?.msg || error?.message || '未知错误');
};

http.interceptors.request.use(
  (config) => {
    // token tenant
    const userModalStore = useModal();
    const token = userModalStore.userInfoData?.access_token;
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    config.headers['TENANT-ID'] = '1';
    if (config.url != '/auth/oauth/token') {
      config.headers['CLIENT-TOC'] = 'Y'; 
    }
    return config;
  },
  (error) => {
    headleError(error);
    return Promise.reject(error);
  }
);

http.interceptors.response.use(
  function (response) {
    const resData = response.data;
    console.log(resData,'resData');
    
    if (resData?.code == 200 || resData?.code == 0 || resData?.access_token) {
      return resData;
    } else if (resData?.code == 401) {
      // headleError(resData);
      // localStorage.clear();
      // return setTimeout(() => { router.replace('/login').catch(() => {}); }, 500)
    } else {
      headleError(resData);
      return Promise.reject(resData);
    }
  },
  function (error) {
    const errorData = error?.response?.data;
    headleError(errorData);
    return Promise.reject(errorData);
  }
);


export default http;
